import { mount } from '@vue/test-utils';
import PasswordToggle from './PasswordToggle.vue';
const faker = require('faker');

describe ('Password Toggle', () => {

    let wrapper;

    it('Hides the password initially', () => {
        let testPassword = faker.internet.password();
        wrapper = mount(PasswordToggle, {
            propsData: {
                password: testPassword
            }
        });
        expect(wrapper.html()).not.toContain(testPassword);
    });

    it('Provides an option to display the password', () => {
        let testPassword = faker.internet.password();
        wrapper = mount(PasswordToggle, {
            propsData: {
                password: testPassword
            }
        });
        expect(wrapper.html()).toContain('Show');
        let toggleButton = wrapper.find('#toggle-password-visibility');
        expect(toggleButton.exists()).toBe(true);
    });

    it('Displays the password after the "Show" button is clicked', (done) => {
        let testPassword = faker.internet.password();
        wrapper = mount(PasswordToggle, {
            propsData: {
                password: testPassword
            }
        });
        // No password initially visible
        expect(wrapper.html()).not.toContain(testPassword);
        let toggleButton = wrapper.find('#toggle-password-visibility');
        expect(toggleButton.exists()).toBe(true);
        toggleButton.trigger('click');
        wrapper.vm.$nextTick().then(() => {
            // Password should be visible after clicking show
            expect(wrapper.html()).toContain(testPassword);
            done();
        });
    })

});
